const BASE = ['transactionScore'];

export const TRANSACTION_SCORE_QUERY_KEYS = {
  getTransactionRiskScoreEvidence: (eventID: string) => [
    ...BASE,
    'evidence',
    eventID,
  ],
};
